<script>
    import { Line } from 'vue-chartjs';
    import VueTypes from 'vue-types';
    import { buildChartData } from './chart-data';

    const TICK_COLOR = 'rgba(255, 255, 255, 0.85)';
    const GRID_COLOR = 'rgba(255, 255, 255, 0.08)';

    export default {
        extends: Line,
        props: {
            daily: VueTypes.array.def([]),
            labels: VueTypes.shape({
                logins: String,
                meditated: String
            }).loose.def({
                logins: 'Unique logins',
                meditated: 'Unique meditated'
            }),
            dates: VueTypes.array.def([])
        },
        data() {
            return {
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        position: 'top',
                        align: 'end',
                        labels: {
                            fontColor: TICK_COLOR,
                            boxWidth: 12,
                            usePointStyle: true
                        }
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                        backgroundColor: '#022341',
                        titleFontColor: '#fff',
                        bodyFontColor: '#fff',
                        callbacks: {
                            title: items =>
                                this.dates[items[0].index] || items[0].xLabel
                        }
                    },
                    hover: { mode: 'index', intersect: false },
                    layout: { padding: { top: 8, right: 8 } },
                    scales: {
                        xAxes: [
                            {
                                gridLines: {
                                    display: false,
                                    drawBorder: false
                                },
                                ticks: {
                                    fontColor: TICK_COLOR,
                                    fontSize: 11,
                                    maxRotation: 0,
                                    autoSkip: true,
                                    maxTicksLimit: 12
                                }
                            }
                        ],
                        yAxes: [
                            {
                                gridLines: {
                                    color: GRID_COLOR,
                                    zeroLineColor: GRID_COLOR,
                                    drawBorder: false
                                },
                                ticks: {
                                    fontColor: TICK_COLOR,
                                    fontSize: 11,
                                    beginAtZero: true,
                                    precision: 0,
                                    maxTicksLimit: 6
                                }
                            }
                        ]
                    }
                }
            };
        },
        watch: {
            daily: 'render'
        },
        mounted() {
            this.render();
        },
        methods: {
            render() {
                this.renderChart(
                    buildChartData(this.daily, this.labels),
                    this.options
                );
            }
        }
    };
</script>
